export interface ActivityLog {
    id: number;
    workshopId: string;
    workshopName: string;
    actionType: ActivityType;
    timestamp: Date;
    details?: string;
}

export enum ActivityType {
    MATERIAL_REQUEST = 'material_request',
    SUGGESTION_SUBMITTED = 'suggestion_submitted',
    DOCUMENT_DOWNLOADED = 'document_downloaded'
}

export interface ActivityFilters {
    startDate?: Date;
    endDate?: Date;
    actionType?: ActivityType;
    workshopId?: string;
}

export interface ActivitySummary {
    totalActions: number;
    materialRequests: number;
    suggestions: number;
    documentDownloads: number;
    activeWorkshops: number;
    activeUsers: number;
    pendingRequests: number;
}